import { ActivatedRouteSnapshot, ViewTransitionInfo } from '@angular/router';

function pathOf(root: ActivatedRouteSnapshot): string {
  const parts: string[] = [];
  for (let s: ActivatedRouteSnapshot | null = root; s; s = s.firstChild) {
    parts.push(...s.url.map(segment => segment.path));
  }
  return '/' + parts.join('/');
}

/**
 * #FUNCIONALIDAD Fundido entre páginas de la tienda pública (View Transitions API del router).
 * Solo anima dentro de /store/…: el panel de administración, los cambios de filtros o de página del catálogo
 * (misma ruta, distinta query) y quien pidió reducir el movimiento en su sistema navegan sin animación.
 */
export function storefrontViewTransition({ transition, from, to }: ViewTransitionInfo): void {
  const fromPath = pathOf(from);
  const toPath = pathOf(to);
  const insideStore = fromPath.startsWith('/store/') && toPath.startsWith('/store/');
  const reduceMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!insideStore || fromPath === toPath || reduceMotion) {
    transition.skipTransition();
  }
}
